import React,{useState,useImperativeHandle,forwardRef,useEffect, useRef} from 'react'
import { Modal,message,Pagination,Empty,Input,Table,Button,Space } from 'antd';
import { unrelatedMerchantList } from '@/services/merchant';
import { unrelatedMerchant,cusRelatedMerchant } from '@/services/customerService';
import { relatedMerchant } from '@/services/account';
import { ResDataType } from "@/services/ajax";
import usePagination from '@/hooks/usePagAndCommon';
import { debounce } from "@/utils"
import { MerchantDataType,merchantColumn } from '../column';
import type { TableProps } from 'antd';
import MerchantContent from '@/pages/merchant/component/merchantDetail';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

 const MerchantList = forwardRef<any,{fromPage?:string}>((props,ref) => {
    const { fromPage='' } = props;
    const { menuId } = useGetCurMenuId();
    const [data,setData] = useState<MerchantDataType[]>([]);
    const dialog = useRef<any>(null);
    const [name,setName] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [curId,setCurId] = useState<number>(0);
    const { page,setPage,pageSize,total,setTotal,isModalOpen, setIsModalOpen,flag,setFlag } = usePagination();
    const showModal = (id:number) => {
      setPage(1);
      setName('');
      fetchData('',id,1);
      setIsModalOpen(true);
      setCurId(id);
    };
    
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const debouncedSearch = debounce((value:string) => {
        fetchData(value,curId,1)
    });
    
    const handleSearch = (value:string) => {
        debouncedSearch(value);
    };
    const fetchData = async (value:string,id:number = curId,pageIndex:number=1) => {
        setFlag(true);
        setPage(pageIndex);
        const params = {
            Name:value,
            PageIndex:pageIndex || page,
            PageSize:100,
            AccountId:id,
        }
        const res = await (fromPage ? unrelatedMerchant(params) : unrelatedMerchantList(params)) as ResDataType;
        if (res.code!= 0) {
          message.error(res.message);
          return;
        } 
        setData(res.data.list);
        setSelectedRowKeys([]);
        res.data.list.forEach((ite:MerchantDataType)=>{
            if (ite.checked) {
                setSelectedRowKeys((prev)=>{
                    return [...prev,ite.id] 
                })
            }
        })
        setTotal(res.data.total);
        setFlag(false);
    }
    const selectMerchant = async(merchantId:React.Key[]) => {
        const params = {accountId:curId,merchantIds:merchantId as number[]}
        const res = await (fromPage? cusRelatedMerchant(params) : relatedMerchant(params)) as ResDataType;
        if (res.code == 0) {
            message.success('操作成功');
            setSelectedRowKeys([]);
            setIsModalOpen(false);
        } else {
            message.error(res.message);
        }
    }

    useEffect(()=> {
        curId && fetchData(name,curId,page); 
    },[page])
    const refresh = () => {
        fetchData('',curId,1); 
    }
    useImperativeHandle(ref, () => ({
        open: (id:number) => showModal(id),
    }))

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
      };
    
      const rowSelection: TableRowSelection<MerchantDataType> = {
        selectedRowKeys,
        onChange: onSelectChange,
      };

    return(
        <Modal maskClosable={false} title="请选择要关联的的商户" open={isModalOpen} okText='确定' cancelText="取消" onOk={()=>{
            if (selectedRowKeys.length == 0) {
                message.warning('请先选择要关联的商户');
                return;
            }
            selectMerchant(selectedRowKeys)
        }} onCancel={handleCancel}>
            <Space size='middle' style={{ marginBottom:'15px'}}>
                <Input value={name} placeholder='商户名称' 
                onChange={(e: React.ChangeEvent<HTMLInputElement>)=>{
                    const value = e.target.value;
                    setName(value);
                    handleSearch(value);
                }} />
                <MenuPermissionControl menuId={menuId} operation="edit" >
                    {
                        !fromPage &&  <Button type="primary" onClick={()=>{
                            dialog.current.open('add')  
                        }} >新增商户</Button>
                    }
                    
                </MenuPermissionControl>
            </Space>
            <div style={{height:'50vh',overflow:'auto'}}>
                <Table<MerchantDataType>
                rowKey='id'
                loading={flag}
                pagination={false}
                scroll={{ x: 'max-content', y: 380 }}
                locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
                rowSelection={rowSelection} columns={merchantColumn} dataSource={data} />
            </div>
            
            <Pagination align="center" showSizeChanger={false} defaultCurrent={page} current={page} pageSize={pageSize} total={total} onChange={(e)=>{ setPage(e); }} />
            <MerchantContent ref={dialog} save={refresh}/>
        </Modal>
    )
})

export default MerchantList